import { useEffect, useState } from 'react'
import TopNav from '../../components/topNavbar/leftNav/topNav'
import LeftNav from '../../components/leftNav/leftNav'
import Explorer from '../../components/explorer/explorer'
import Footer from '../../components/footer/footer'
import Home from '../home/home'
import Projects from '../projects/projects'
import Me from '../me/me'
import Tapbar from '../../components/tapbar/tapbar'
// import News from '../news/news'
import Contact from '../contact/contact'
import Error from '../error/error'

import { Route, Routes, useLocation } from 'react-router-dom'
import { useCookies } from 'react-cookie'
import { appConfig } from '../../config'

import './app.scss'
import UnderConstruction from '../underConstruction/underConstruction'

const underConstruction = true

function App() {
  const [explorerSize, setExplorerSize] = useState(200)
  const [footerSize, setFooterSize] = useState(200)
  const [cookies] = useCookies(['themen'])
  const [contactForm, setContactForm] = useState({
    name: '',
    mail: '',
    text: ''
  })

  const location = useLocation()

  const [openTabs, setOpenTabs] = useState(() => {
    const findConfig = appConfig.find(obj => obj.path === location.pathname )
    return [{ path: location.pathname, title: findConfig?.title ?? 'error'  }]
  })

  useEffect(() => {
    if(cookies.themen) {
      document.getElementById('theme')?.classList.add(cookies.themen)
    }
  }, [cookies.themen])
  
  useEffect(() => {
    const newOpenTabs =[...openTabs]
    const findConfig = appConfig.find(obj => obj.path === location.pathname )
    
    if(!newOpenTabs.find(tab => tab.path === location.pathname)) {
      newOpenTabs.push({ path: location.pathname, title: findConfig?.title ?? 'error' })
      setOpenTabs(newOpenTabs)
    }
  }, [location.pathname, openTabs])

  if(underConstruction)  {
    return (
      <UnderConstruction />
    )
  }

  return (
    <div className='app'>
      <TopNav explorerSize={explorerSize} setExplorerSize={setExplorerSize} footerSize={footerSize} setFooterSize={setFooterSize} />

      <div className='app-content' style={{ gridTemplateColumns: `60px ${explorerSize}px 1fr` }}>
        <LeftNav />
        <Explorer explorerSize={explorerSize} setExplorerSize={setExplorerSize} />

        <div className='content-footer' style={{ gridTemplateRows: `44px 1fr ${footerSize}px` }}>
          <Tapbar openTabs={openTabs} setOpenTabs={setOpenTabs}/>
          <Routes>
            <Route path='/' element={<Home />} />
            {/*<Route path='/news' element={<News />} />*/}
            <Route path='/projects' element={<Projects />} />
            <Route path='/contact' element={<Contact contactForm={contactForm} setContactForm={setContactForm}/>} />
            <Route path='/aboutme' element={<Me />} />
            <Route path='*' element={<Error />} />
          </Routes>
          <Footer
            footerSize={footerSize}
            setFooterSize={setFooterSize}
          />
        </div>
      </div>
    </div>
  )
}

export default App
